import { YoutubeLatestVideo } from '../../schema/youtube/youtube-latest-video';
import { CakeApiBase } from '../CakeApiBase';

export class YoutubeApi extends CakeApiBase {
  async getLatestVideos() {
    return this.requestManager.get<YoutubeLatestVideo[]>('/youtube-latest-videos');
  }
}
